import { NotifyHelper } from "../../../helpers/toast";
import { eKhoiActionTypeDefine } from "../../action-types/category/IKhoiActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const khoiActions = {
    ...generateActions(eKhoiActionTypeDefine, "KHOI"),
    ...generateActionForKey(eKhoiActionTypeDefine, "KHOI", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eKhoiActionTypeDefine, "KHOI", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eKhoiActionTypeDefine, "KHOI", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eKhoiActionTypeDefine, "KHOI", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eKhoiActionTypeDefine, "KHOI", "LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),
};
